export const CoverageType = {
  personalPropertyCoverage: 'personalPropertyCoverage',
  personalLiabilityCoverage: 'personalLiabilityCoverage',
  medicalPayments: 'medicalPayments',
  lossOfUse: 'lossOfUse',
  deductible: 'deductible',
  theft: 'theft',
  windHail: 'windHail',
  hurricane: 'hurricane',
  waterBackup: 'waterBackup',
  earthquake: 'earthquake',
  petDamage: 'petDamage',
  identityFraud: 'identityFraud',
} as const;

export type CoverageType = typeof CoverageType[keyof typeof CoverageType];
